import React from "react";

import Cards from './Cards';
import "./ContactInfo.css";

const ContactInfo = ({ home }) => 
  <section className="ContactInfo jumbotron bg-transparent container px-0 pb-0 pt-0">
    <Cards home={home} />
  </section>

export default ContactInfo;
